import logo from './logo.svg';
import bnb from './bnb.png'
import eth from './eth.png'
import './App.css';
import React from 'react';
import './preload.css'
import {Routes,Route,Link,BrowserRouter as Router,Navigate} from 'react-router-dom';
import {motion} from 'framer-motion'
import { Icon } from '@iconify/react';
import {useMoralis,useWeb3Transfer,useOneInchTokens,useOneInchSwap,useERC20Balances,useChain,useOneInchQuote,useNativeBalance,useNativeTransactions} from 'react-moralis';


function App() {
  function copy(what) {
  /* Get the text field */
  var copyText = document.getElementById(what).textContent;
  //alert(copyText)
  /* Select the text field */
  //copyText.select();
  //copyText.setSelectionRange(0, 99999); /* For mobile devices */

   /* Copy the text inside the text field */
 navigator.clipboard.writeText(copyText);

  /* Alert the copied text */
  alert("Copied the text: " + copyText);
}



  const ethereum =window.ethereum;

  const [sendAddress,setSendAddress]=React.useState('')
  const [sendAmount2,setSendamount] = React.useState(0.0)

  const [swapAddress,setSwapAddress]=React.useState('')
  const [swapAddress2,setSwapAddress2]=React.useState('')
  const [swapAmount,setSwapamount] = React.useState(0.0)
  const [addr,setAddr] = React.useState('user');
  const [drop,setDrop] = React.useState('choose Token')
  const [drop2,setDrop2] = React.useState('choose Token')

  const { authenticate, isAuthenticated, isAuthenticating, user, logout,Moralis,enableWeb3 } = useMoralis();
  const { switchNetwork, chainId, chain, account } = useChain();

  //const { getSupportedTokens, data, isFetchingInch, isLoading, errorInch } = useOneInchTokens({ chain: 'bsc' });
  const { getBalances, data: balance, nativeToken, errorBal, isLoadingBal } = useNativeBalance();
  const { getNativeTransations, data, errorTrans, isLoadingTrans, isFetchingTrans } = useNativeTransactions();
  
  //const [balance2,setBalance] = React.useState(''|| balance.formatted)
  console.log(chain)
   
  React.useEffect(()=> {console.log(balance);Moralis.enableWeb3();},[])

  console.log(balance)
  console.log([]||data.result)
  const [load,isLoaded]=React.useState(true)

function Async(){
   return new Promise(resolve=>setTimeout(()=>{resolve({data:{loader:false}});document.body.style.backgroundColor='silver'},5000))

}
React.useEffect(()=>{Async().then(result=>{isLoaded(result.data.loader)});},[load])

  const trans = [] || data.result
  
  //const { swap, dataSwap, isFetchingSwap, isLoadingSwap, errorSwap, } = useOneInchSwap
  //alert(sendAmount2)
 //console.log(data)
  async function login(){
    await authenticate({ signingMessage: "Connect Sapa Wallet" })
}

React.useEffect(()=> {if (isAuthenticated){
   setAddr(user.get('ethAddress'))
}

},[isAuthenticated])

const {fetch,error,isFetching} = useWeb3Transfer({
    amount:Moralis.Units.ETH(sendAmount2||0.0),
    receiver:sendAddress||'',type:'native'

  })
const handleAmount =(e)=>{
   setSendamount(e.target.value)
   console.log(e.target.value)
}

const handleAddress =(e)=>{
   setSendAddress(e.target.value)
   console.log(e.target.value)
}



//alert()
const options={
  chain:'bsc',
  fromTokenAddress: swapAddress || '',
  toTokenAddress:   swapAddress2 || '',
  amount: swapAmount || 0.0,
  fromAddress: addr || '',
  slippage:1,

}
const logo2 = "cryptocurrency:"

//console.log(useOneInchSwap(['a','b'],options))
  return (
    <>
    { load? <Preloader />:
    <div>
    <div class="container-fluid"><br />
    
   {isAuthenticated? '' :<div class="card bg-danger">
    <div class="card-body">connect metamask for full functionalities </div>
   </div>}
    <div class="container" style={{backgroundColor:'white'}}>
    
    <div class="row row-cols-1">
      <div class="col p-3" style={{color:'red',backgroundColor:'silver'}}>
      <span ><motion.button class="rounded border-danger" style={{width:'130px',backgroundColor:'white',color:'tomato'}} animate={{x:[0,-20,40,-40,0]}} transition={{duration:0.5,delay:0.5}}><b>SAPA WALLET</b></motion.button></span>
      {isAuthenticated? <button class="rounded-pill disabled={isAuthenticating} float-end text-center" onClick={()=>{Moralis.enableWeb3();logout()}} style={{width:'130px',backgroundColor:'white',color:'tomato'}}>
      disconnect
      </button> :<button class="rounded-pill float-end text-center" disabled={isAuthenticating} onClick={login}  style={{width:'130px',backgroundColor:'white',color:'tomato'}}>
      connect
      </button>}</div>
      <div class="col p-3 border border-dark" style={{backgroundColor:'white',height:'auto'}}>
      <Copy copy={copy} addr={addr} isAuthenticated={isAuthenticated} id='wallet'/><hr />
        
        <Routes>
        <Route path='/' element={<Home balance={balance.formatted} isAuthenticated={isAuthenticated} chain={chain}/>} />
        <Route path='transactions' element={<Trans getNativeTransations={getNativeTransations} trans={trans}/>} />
        <Route path='/sapa' element={<Sapa/>} />
        <Route path='/preload' element={<Preloader/>} />
        <Route element={<Navigate exact from="/" to="preload" />} />
        <Route path='/swap' element={<SendSwap sendAmount={sendAmount2} sendAdress={sendAddress} chain={chain}


        handleAddress={handleAddress} handleAmount={handleAmount} fetch={fetch} copy={copy} addr={addr} 
        isAuthenticated={isAuthenticated} isFetching={isFetching} balance={balance.formatted} drop={drop} setDrop={setDrop} drop2={drop2} setDrop2={setDrop2} />} />
        </Routes>
        
      

         <br /><br /><br /><br /><br /><br /><br /><br />
         <motion.div class="bi-cursor-fill" onClick={()=>setSendAddress('0x60c468Ae619D8AE4852c74f01C1838B766cc041a')} animate={{x:[0,10,0], y:[0,-20,0],}} transition={{duration:3,repeat: 'Infinity', delay:3}} data-bs-toggle="modal" data-bs-target="#desapa"  style={{fontSize:'40px'}}><span style={{fontSize:'10px'}}>deSAPA dev</span></motion.div>
         <div class="card shadow" style={{backgroundColor:'white',color:'black',height:'60px'}}>
        <div class="card-body">
        <center><Link to='/'><span class="bi-house-fill text-center" style={{fontSize:'33px'}} ></span></Link>
        <Link to='/sapa'><span class="float-end" style={{fontSize:'20px',color:'red', position:'relative',top:'13px'}} ><b>Sapa2.0</b></span></Link>
        <Link to='/transactions'><span class="bi-receipt float-start" style={{fontSize:'33px'}} ></span></Link>
        </center>
        </div>

        </div>
        </div>


     </div>  
     </div>


  </div>
  <div class="modal fade" id="desapa">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h4 class="modal-title">Send &nbsp;&nbsp; </h4><span style={{color:'red'}}> <b>you are sending a tip to the developer...</b></span>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
         <form>
  <div class="mb-3 mt-3">
  <label for="amount" class="form-label">Amount</label><br />
   <div class="input-group mb-3">
  <button class="btn btn-outline-primary btn-primary" type="button">
  <span style={{color:'white'}}><Icon icon={chain==null? "cryptocurrency:bnb": logo2 + chain.shortName} width="50" height="50" /></span></button>
    <input type="number" min='0' class="form-control"  id="amount" onChange={handleAmount} placeholder="Enter amount" name="amount" />
</div>
    
  </div>
  <div class="mb-3">
    <label for="pwd" class="form-label">Address</label>
    <input type="text" class="form-control" id="addr" placeholder="Enter Address"  value="0x60c468Ae619D8AE4852c74f01C1838B766cc041a" onChange={handleAddress} name="addr" />
  </div>
  <div class="form-check mb-3">
  </div>
  <button type="button" onClick={()=>fetch()} disabled={isFetching} class="btn btn-primary">Submit</button>
</form>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
  </div>
}
  </>
  );
}
 function SendSwap(i){
  const logo = "cryptocurrency:"

   return(

       <div class="row row-cols-1">
       <div class="col p-3" style={{backgroundColor:'white',height:'auto'}}>
       <div class="card" style={{height:'100px'}}>
        <div class="card-body border border-white" style={{backgroundColor:'ghostwhite'}}><center><span>
        <Icon icon={i.chain==null? "cryptocurrency:bnb": logo + i.chain.shortName} width="50" height="50" />
        </span><span style={{position:'relative',top:'3px',left:'-0px',fontSize:'15px',color:'tomato',}}><h4>{i.balance}</h4></span><br /><br /></center></div>
        </div><br /><br /> <br />

        <div><center><i class="bi-arrow-right-square-fill" style={{fontSize:'30px'}} data-bs-toggle="modal" data-bs-target="#send">
         <span style={{position:'relative',top:'20px',left:'-32px',fontSize:'15px'}}>Send</span>
        </i>
        <i class="bi-currency-exchange" style={{fontSize:'30px'}} data-bs-toggle="modal" data-bs-target="#swap">
         <span style={{position:'relative',top:'20px',left:'-32px',fontSize:'15px'}}>Swap</span>
        </i>
        <i class="bi-arrow-down-square-fill" style={{fontSize:'30px'}} data-bs-toggle="modal" data-bs-target="#recieve">
         <span style={{position:'relative',top:'20px',left:'-32px',fontSize:'15px'}}>Recieve</span>
        </i>
        </center></div><br /><br />
        
       </div><br />
             <p class='text-center'>History</p><hr class='shadow' />

<div class="modal fade" id="send">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h4 class="modal-title">Send</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
         <form>
  <div class="mb-3 mt-3">
  <label for="email" class="form-label">Amount</label><br />
   <div class="input-group mb-3">
  <button class="btn btn-outline-primary btn-primary" type="button">
  <span style={{color:'white'}}><Icon icon={i.chain==null? '': logo + i.chain.shortName} width="50" height="50" />
</span></button>
    <input type="number" min='0' class="form-control"  id="amount" onChange={i.handleAmount} placeholder="Enter amount" name="amount" />
</div>
    
  </div>
  <div class="mb-3">
    <label for="pwd" class="form-label">Address</label>
    <input type="text" class="form-control" id="addr" placeholder="Enter Address" onChange={i.handleAddress} name="addr" />
  </div>
  <div class="form-check mb-3">
  </div>
  <button type="button" onClick={()=>i.fetch()} disabled={i.isFetching} class="btn btn-primary">Submit</button>
</form>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>


<div class="modal fade" id="swap">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h4 class="modal-title">Swap  &nbsp; &nbsp;</h4>
        <span style={{color:'red'}}>swap function will be available @ Sapa 2.0 release</span>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        <form>
  <div class="mb-3 mt-3">
  <label for="email" class="form-label"><b>Swap from</b></label>
    <div class="input-group mt-3 mb-3">
  <button type="button" class="btn btn-dark dropdown-toggle" data-bs-toggle="dropdown">
    {i.drop}
  </button>
  <ul class="dropdown-menu">
    <li onClick={()=>i.setDrop(<span>BSC <img height='35px' width='35px' 
    src={bnb} /></span>)}>
    <a class="dropdown-item" href="#">BSC<img height='35px' width='35px' 
    src={bnb} /></a></li>

    <li onClick={()=>i.setDrop(<span>CAKE <img height='35px' width='35px' 
    src="https://tokens.1inch.io/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82.png" /></span>)}>
    <a class="dropdown-item" href="#">CAKE<img height='35px' width='35px' 
    src="https://tokens.1inch.io/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82.png" /></a></li>
    
    <li onClick={()=>i.setDrop(<span>USDT <img height='35px' width='35px' 
    src="https://tokens.1inch.io/0xdac17f958d2ee523a2206206994597c13d831ec7.png" /></span>)}>
    <a class="dropdown-item" href="#">USDT<img height='35px' width='35px' 
    src="https://tokens.1inch.io/0xdac17f958d2ee523a2206206994597c13d831ec7.png" /></a></li>
    

    <li onClick={()=>i.setDrop(<span>ETH <img height='35px' width='35px' 
    src="https://tokens.1inch.io/0x2170ed0880ac9a755fd29b2688956bd959f933f8.png" /></span>)}>
    <a class="dropdown-item" href="#">ETH<img height='35px' width='35px' 
    src="https://tokens.1inch.io/0x2170ed0880ac9a755fd29b2688956bd959f933f8.png" /></a></li>
  </ul>
  <input type="number" min='0' class="form-control" placeholder="Amount" />
</div>
<i class="bi-arrow-down-up float-end" style={{fontSize:'25px'}}></i>
<label for="email" class="form-label"><b>Swap to</b></label>
<div class="input-group mt-3 mb-3">
  <button type="button" class="btn btn-dark dropdown-toggle" data-bs-toggle="dropdown">
    {i.drop2}
  </button>
  <ul class="dropdown-menu">
    <li onClick={()=>i.setDrop2(<span>BSC <img height='35px' width='35px' 
    src={bnb} /></span>)}>
    <a class="dropdown-item" href="#">BSC<img height='35px' width='35px' 
    src={bnb} /></a></li>

    <li onClick={()=>i.setDrop2(<span>CAKE <img height='35px' width='35px' 
    src="https://tokens.1inch.io/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82.png" /></span>)}>
    <a class="dropdown-item" href="#">CAKE<img height='35px' width='35px' 
    src="https://tokens.1inch.io/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82.png" /></a></li>
    
    <li onClick={()=>i.setDrop2(<span>USDT <img height='35px' width='35px' 
    src="https://tokens.1inch.io/0xdac17f958d2ee523a2206206994597c13d831ec7.png" /></span>)}>
    <a class="dropdown-item" href="#">USDT<img height='35px' width='35px' 
    src="https://tokens.1inch.io/0xdac17f958d2ee523a2206206994597c13d831ec7.png" /></a></li>

    <li onClick={()=>i.setDrop2(<span>ETH <img height='35px' width='35px' 
    src="https://tokens.1inch.io/0x2170ed0880ac9a755fd29b2688956bd959f933f8.png" /></span>)}>
    <a class="dropdown-item" href="#">ETH<img height='35px' width='35px' 
    src="https://tokens.1inch.io/0x2170ed0880ac9a755fd29b2688956bd959f933f8.png" /></a></li>
  </ul>

  <input type="number" class="form-control" placeholder="Amount" />
</div>
  </div>
  <button type="button" disabled class="btn btn-primary">Swap</button>
</form>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="recieve">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h4 class="modal-title">Recieve</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        <Copy copy={i.copy} addr={i.addr} isAuthenticated={i.isAuthenticated} id='wallet2'/>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>

       </div>


    )


 }

 function Home(i){
  const logo = "cryptocurrency:"
  return(<>
    <div class="card" style={{height:'100px'}}>
        <div class="card-body border border-white"  style={{backgroundColor:'ghostwhite'}}><center><span><Icon icon={i.chain==null? "cryptocurrency:bnb": logo + i.chain.shortName} width="50" height="50" /></span><span style={{position:'relative',top:'3px',left:'-0px',fontSize:'15px',color:'tomato',}}><h4>{i.balance}</h4></span><br /><br /></center></div>
        </div><br />
        <div class='container'>
          <div class="card" style={{height:'60px'}}>
        <div class="card-body border border-white" style={{backgroundColor:'black',color:'tomato'}}>{i.chain==null? 'BNB': i.chain.nativeCurrency.symbol}
         <Link to='/swap'><span class='bi-arrow-right float-end' style={{color:'tomato'}}></span></Link>
        
        </div>

        </div>


        </div>
       </>
    )

 }

 function Copy(i){

  return(<center>
      <span id={i.id} style={{fontSize:'14px'}}><b>{i.isAuthenticated? i.addr:'sapa bien merci'}</b>
      {i.isAuthenticated && <i class="bi-stickies" onClick={()=>i.copy(i.id)}></i>}</span></center>
      )

 }

 function Trans(i){
  return(<>
    <div class="row row-cols-1">
      <div class="col p-3" style={{color:'black'}}>
      <center><h3>Recent transactions </h3></center>
    <div>
      {i.trans.map(data=>{
        return <div class="card" style={{backgroundColor:'ghostwhite'}}>
              <div class="card-body">
              <span>Txn Hash: <b>{data.hash}</b></span><br />
              <span>sender: <b>{data.from_address}</b></span><br/>
              <span>recipient: <b>{data.to_address}</b></span> <br/>
              <span>value: <b>{data.value}</b></span><br />
              <span>status: <b>{data.receipt_status}</b></span><br />




              </div>
      </div> })}
    </div><br />

        

        </div>
        </div>
       </>
    )

 }

 function Sapa(i){

  return(
       <>
       <div style={{color:'black'}}>
       <center><h3>sapa 2.0 features <span style={{color:'red'}}>(Coming soon)</span></h3></center><br />

       <motion.div whileInView={{opacity:1}} initial={{opacity:0}} transition={{duration:1}} class="card" style={{color:'white',backgroundColor:'black'}}>
      <div class="card-body">Swap function support</div>
       </motion.div> <br />

       <motion.div whileInView={{opacity:1}} initial={{opacity:0}} transition={{duration:1,delay:0.1}} class="card" style={{color:'white',backgroundColor:'black'}}>
      <div class="card-body">wallet as a  service</div>
       </motion.div><br />

       <motion.div whileInView={{opacity:1}} initial={{opacity:0}} transition={{duration:1,delay:0.2}} class="card" style={{color:'white',backgroundColor:'black'}}>
      <div class="card-body">sapa Staking</div>
       </motion.div><br />

       <motion.div whileInView={{opacity:1}} initial={{opacity:0}} transition={{duration:1,delay:0.3}} class="card" style={{color:'white',backgroundColor:'black'}}>
      <div class="card-body">$sapa token</div>
       </motion.div><br />
 
      <motion.div whileInView={{opacity:1}} initial={{opacity:0}} transition={{duration:1,delay:0.4}} class="card" style={{color:'white',backgroundColor:'black'}}>
      <div class="card-body">More token support</div>
       </motion.div>




        </div>
        </>
        )

 }

 function Preloader(){

  return(
   <center><div class="loader text-center"><motion.p initial={{opacity:0}} animate={{rotate:360,scale:[0,0.5,1],opacity:1}} transition={{duration:2,delay:1}} style={{fontSize:'45px', color:'red'}}><b>SAPA</b></motion.p>
   <motion.p animate={{opacity:[0,0.5,1],scale:[0.8,1.5,1.8]}} initial={{opacity:0}} transition={{duration:3,delay:3}} style={{fontSize:'8px',color:'black'}}>let your pain... inspire you...</motion.p>
   </div></center>
  )
}
export default App;
